import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CadCartaocreditoComponent} from '../cad-cartaocredito/cad-cartaocredito.component';
import {FaturaAvulsaPublicaService} from './fatura-avulsa-publica.service';

@Component({
  selector: 'app-fatura-avulsa-pagamento',
  templateUrl: './fatura-avulsa-pagamento.component.html',
  styleUrls: ['./fatura-avulsa-pagamento.component.scss']
})
export class FaturaAvulsaPagamentoComponent implements OnInit, OnDestroy {
  @ViewChild('cartaoComponent') cartaoComponent: CadCartaocreditoComponent;
  codigo: string;
  dados: any;
  carregando = true;
  processando = false;
  verificandoStatusLocal = false;
  erro: string;
  forma = 'pix';
  private polling: any;
  private chaveIdempotencia: string;
  private assinaturaTentativaCartao: string;

  constructor(private rota: ActivatedRoute, private service: FaturaAvulsaPublicaService) {}

  ngOnInit() {
    this.codigo = this.rota.snapshot.params.codigo;
    this.service.obtenha(this.codigo).then(dados => this.receba(dados)).catch(() => {
      this.erro = 'Link inválido ou indisponível';
      this.carregando = false;
    });
  }

  ngOnDestroy() { this.parePolling(); }

  get fatura(): any { return this.dados?.fatura || {}; }
  get estadoFinal(): boolean {
    return ['Paga', 'Cancelada', 'Expirada', 'Reembolsada', 'Contestada', 'Chargeback']
      .indexOf(this.fatura.status) >= 0;
  }
  get pagavel(): boolean { return ['Aberta', 'Vencida'].indexOf(this.fatura.status) >= 0; }

  sincronize() {
    if(this.processando || this.estadoFinal) return;
    this.processando = true;
    this.service.sincronize(this.codigo).then(dados => this.receba(dados)).catch(() => {})
      .then(() => this.processando = false);
  }

  pagueComCartao(cartao: any) {
    if(this.processando) return;
    this.processando = true;
    this.erro = null;
    const assinatura = this.crieAssinaturaTentativaCartao(cartao);
    if(this.assinaturaTentativaCartao !== assinatura) {
      this.chaveIdempotencia = null;
      this.assinaturaTentativaCartao = assinatura;
    }
    this.chaveIdempotencia = this.chaveIdempotencia || this.crieChave();
    this.service.pagueComCartao(this.codigo, cartao, this.chaveIdempotencia).then(dados => {
      this.receba(dados);
      this.chaveIdempotencia = null;
      this.assinaturaTentativaCartao = null;
    }).catch(erro => {
      console.log(erro)
      const mensagem = erro || 'Não foi possível concluir a cobrança';
      this.cartaoComponent?.exibaErro(mensagem);
    }).then(() => this.processando = false);
  }

  private receba(dados: any) {
    this.dados = dados;
    this.carregando = false;
    if(!this.fatura.pix?.disponivel && this.fatura.permiteCartao) this.forma = 'cartao';
    if(this.estadoFinal) this.parePolling(); else if(this.fatura.pix?.disponivel) this.iniciePolling();
  }

  private iniciePolling() {
    if(!this.polling) this.polling = setInterval(() => this.verifiqueStatusLocal(), 10000);
  }

  private verifiqueStatusLocal() {
    if(this.verificandoStatusLocal || this.processando || this.estadoFinal) return;
    this.verificandoStatusLocal = true;
    this.service.obtenha(this.codigo).then(dados => this.receba(dados)).catch(() => {})
      .then(() => this.verificandoStatusLocal = false);
  }

  private parePolling() {
    if(this.polling) clearInterval(this.polling);
    this.polling = null;
  }

  private crieChave(): string {
    const aleatorio = typeof crypto !== 'undefined' && (crypto as any).randomUUID ?
      (crypto as any).randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    return `fatura-publica-${aleatorio}`;
  }

  private crieAssinaturaTentativaCartao(cartao: any): string {
    return JSON.stringify([
      cartao?.ultimosDigitos || '', cartao?.validade || '', cartao?.nome || '',
      cartao?.cvv || '', cartao?.numeroParcelas || 1
    ]);
  }
}
